/**
 * free-shipping-bar.js
 * ─────────────────────────────────────────────────────────────
 * Keeps the shipping bar in sync with the live cart total
 * without a page reload — works alongside AJAX cart drawers.
 *
 * Include this file via your theme.liquid or as a bundled asset:
 *   <script src="{{ 'free-shipping-bar.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  const FREE_SHIPPING_CENTS = 5000; // $50.00 — match your threshold

  // ─── Helpers ────────────────────────────────────────────────

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateBar(cartTotalCents) {
    const bars = document.querySelectorAll('.free-shipping-bar');
    if (!bars.length) return;

    const remaining = Math.max(FREE_SHIPPING_CENTS - cartTotalCents, 0);
    const progress  = Math.min((cartTotalCents / FREE_SHIPPING_CENTS) * 100, 100);
    const unlocked  = cartTotalCents >= FREE_SHIPPING_CENTS;

    bars.forEach(bar => {
      const fill    = bar.querySelector('.free-shipping-bar__fill');
      const message = bar.querySelector('.free-shipping-bar__message');

      if (fill) {
        fill.style.width = progress + '%';
        fill.classList.toggle('free-shipping-bar__fill--unlocked', unlocked);
      }

      if (message) {
        message.classList.toggle('free-shipping-bar__message--unlocked', unlocked);
        if (unlocked) {
          message.innerHTML = '🎉 You\'ve unlocked free shipping!';
        } else {
          message.innerHTML = `You're <strong>${formatMoney(remaining)}</strong> away from free shipping`;
        }
      }
    });
  }

  // ─── Cart fetch ─────────────────────────────────────────────

  async function refreshCartTotal() {
    try {
      const res  = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      updateBar(data.total_price);
    } catch (e) {
      // Fail silently — bar just won't update until next page load
    }
  }

  // ─── Event listeners ────────────────────────────────────────

  // Fired by Dawn and most modern Shopify themes after cart changes
  document.addEventListener('cart:updated',  refreshCartTotal);
  document.addEventListener('cart:refresh',  refreshCartTotal);

  // Older themes / custom AJAX add-to-cart patterns
  document.addEventListener('added.ajaxProduct', refreshCartTotal);

  // Intercept native fetch calls to /cart/add & /cart/change
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url ?? '';
    if (/\/cart\/(add|change|update)/.test(url)) {
      return _fetch.apply(this, args).then(res => {
        if (res.ok) refreshCartTotal();
        return res;
      });
    }
    return _fetch.apply(this, args);
  };

  // Intercept XMLHttpRequest for legacy themes
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (/\/cart\/(add|change|update)/.test(url)) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) refreshCartTotal();
      });
    }
    return _open.call(this, method, url, ...rest);
  };

  // Initial render
  document.addEventListener('DOMContentLoaded', refreshCartTotal);
})();
